import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE || "http://localhost:5050").replace(/\/$/, "");

const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});

// 🔐 Attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // 🔐 Token expired or invalid
      localStorage.clear();
      window.location.href = "/welcome";
    }
    return Promise.reject(error);
  }
);

export default api;